<div *ngIf="(backendValidationErrorsList)!.length > 0"
  class="
        notice
        d-flex
        bg-light-warning
        rounded
        border-warning border border-dashed
        p-6
        mb-10
      "
>
      <span
        [inlineSVG]="'./assets/media/icons/duotune/general/gen044.svg'"
        class="svg-icon svg-icon-2tx svg-icon-warning me-4"
      ></span>
  <div class="d-flex flex-stack flex-grow-1">
    <div class="fw-bold">
      <h4 class="text-gray-800 fw-bolder">Nie udało się stworzyć nowego konta</h4>
      <div *ngFor="let errorMsg of (backendValidationErrorsList)" class="fs-6 text-gray-600">
        {{ errorMsg }}
      </div>
    </div>
  </div>
</div>
